export const TABS = {
  ACCOUNT: 'account',
  FINANCIAL_INSTITUTIONS: 'financial-institutions',
  PLAN_AND_BILLING: 'plan-and-billing',
} as const
